var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "17px",
    viewBox: "0 0 29 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 6 Copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.223437037 27.2592593 0.223437037 27.2592593 15.7037037 0 15.7037037"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sign-Up",
    transform: "translate(-1003.000000, -663.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "eye-path",
    fill: "black",
    id: "Group-6-Copy-2",
    transform: "translate(1017.370370, 671.500000) scale(1, -1) translate(-1017.370370, -671.500000) translate(1003.370370, 663.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 0.072889)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.629037,14.2219556 C13.2577778,14.2095111 6.18222222,13.8841778 1.66074074,7.96358519 C6.26785185,1.93336296 13.5688889,1.7064 13.6157037,1.70462222 C13.6906667,1.7061037 20.9780741,1.91321481 25.5988148,7.96358519 C21.0877037,13.8675852 13.9934815,14.2086222 13.629037,14.2219556 M27.1223704,7.53454815 C22.0983704,0.462251852 13.9863704,0.229955556 13.6157037,0.223437037 C13.2728889,0.229659259 5.16088889,0.462251852 0.136888889,7.53454815 C-0.0456296296,7.79143704 -0.0456296296,8.13573333 0.136888889,8.39262222 C5.16088889,15.4646222 13.2728889,15.6969185 13.6157037,15.7037333 L13.6296296,15.7037333 L13.6435556,15.7037333 C13.9863704,15.6972148 22.0983704,15.4646222 27.1223704,8.39262222 C27.3048889,8.13573333 27.3048889,7.79143704 27.1223704,7.53454815",
    id: "Fill-1",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.6296296,11.7975704 C11.5161481,11.7975704 9.79644444,10.1104593 9.79644444,8.03638519 C9.79644444,5.96231111 11.5161481,4.2752 13.6296296,4.2752 C15.7431111,4.2752 17.4628148,5.96231111 17.4628148,8.03638519 C17.4628148,10.1104593 15.7431111,11.7975704 13.6296296,11.7975704 M13.6296296,2.79371852 C10.698963,2.79371852 8.31496296,5.14571852 8.31496296,8.03638519 C8.31496296,10.9273481 10.698963,13.2790519 13.6296296,13.2790519 C16.5602963,13.2790519 18.9442963,10.9273481 18.9442963,8.03638519 C18.9442963,5.14571852 16.5602963,2.79371852 13.6296296,2.79371852",
    id: "Fill-4"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIc);
export default __webpack_public_path__ + "static/media/eye-ic.2604e11c7608aa573e37418a1f84943a.svg";
export { ForwardRef as ReactComponent };